import React from 'react';
import {LineChart} from "@mui/x-charts";

//TODO: use CSS classes for manager colors...
const colors = [
    '#4e79a7',
    '#f28e2c',
    '#e15759',
    '#76b7b2',
    '#59a14f',
    '#edc949',
    '#af7aa1',
    '#ff9da7',
    '#9c755f',
    '#bab0ab',
];

const buildXLabels = (seriesMaps) => {
    const numWeeks = seriesMaps.length > 0 ? Math.max(0, ...seriesMaps.map(s => s.data.length)) : 0;
    const labels = [];
    for (let w = 1; w <= numWeeks; w++) {
        labels.push(w === 1 ? 'Week 1' : `${w}`);
    }
    return labels;
};

const buildWeeklyCorrectCounts = (scoreboard) => {
    const {managerNames = [], picks = {}, scores = {}} = scoreboard;
    const weeklyCorrectCounts = {};
    let maxWeekNumPlayed = 0;

    for (const manager of managerNames) {
        const managerPicks = picks[manager] || {};
        const managerScores = scores[manager] || {};

        for (const pickDef of Object.values(managerPicks)) {
            const teamResults = managerScores[pickDef.team] || {};
            for (const [weekNumStr, weekData] of Object.entries(teamResults)) {
                if (weekData && weekData.game_result !== null && weekData.game_result !== undefined && weekData.game_result !== '') {
                    const weekNum = parseInt(weekNumStr, 10);
                    if (!isNaN(weekNum)) {
                        maxWeekNumPlayed = Math.max(maxWeekNumPlayed, weekNum);
                    }
                }
            }
        }
    }

    for (const manager of managerNames) {
        weeklyCorrectCounts[manager] = [];
        const managerPicks = picks[manager] || {};
        const managerScores = scores[manager] || {};

        for (let w = 1; w <= maxWeekNumPlayed; w++) {
            weeklyCorrectCounts[manager].push(0);
        }

        for (const pickDef of Object.values(managerPicks)) {
            const teamResults = managerScores[pickDef.team] || {};
            for (let w = 1; w <= maxWeekNumPlayed; w++) {
                const gameResult = teamResults[`${w}`]?.game_result;
                if ((pickDef.to_win && gameResult === 'W') || (!pickDef.to_win && gameResult === 'L')) {
                    weeklyCorrectCounts[manager][w - 1] += 1;
                }
            }
        }
    }

    // Cumulative sums across weeks
    for (const manager of managerNames) {
        for (let w = 2; w <= maxWeekNumPlayed; w++) {
            weeklyCorrectCounts[manager][w - 1] =
                (weeklyCorrectCounts[manager][w - 1] || 0) + (weeklyCorrectCounts[manager][w - 2] || 0);
        }
    }

    // Add tiny offsets for overlapping lines
    const usedSpots = {};
    for (const manager of managerNames) {
        for (let w = 1; w <= maxWeekNumPlayed; w++) {
            if (!usedSpots[w]) usedSpots[w] = [];
            let stored = false;
            while (!stored) {
                if (usedSpots[w].includes(weeklyCorrectCounts[manager][w - 1])) {
                    weeklyCorrectCounts[manager][w - 1] += 0.05;
                } else {
                    usedSpots[w].push(weeklyCorrectCounts[manager][w - 1]);
                    stored = true;
                }
            }
        }
    }

    return weeklyCorrectCounts;
};

const buildSeriesMaps = (managerList, weeklyCorrectCounts) => {
    const seriesMaps = [];
    for (const manager of managerList) {
        seriesMaps.push({
            label: manager,
            data: weeklyCorrectCounts[manager] || [],
            color: colors[managerList.indexOf(manager) % colors.length],
            valueFormatter: (v) => Math.floor(v)
        });
    }
    return seriesMaps;
};

export const WinsPoolChart = ({picks: scoreboard, scoreboard: directScoreboard}) => {
    const data = directScoreboard || scoreboard;
    const hasData = Boolean(
        data &&
        Array.isArray(data.managerNames) &&
        data.managerNames.length > 0 &&
        data.scores &&
        Object.keys(data.scores).length > 0
    );

    if (hasData) {
        const weeklyCorrectCounts = buildWeeklyCorrectCounts(data);
        const seriesMaps = buildSeriesMaps(data.managerNames, weeklyCorrectCounts);
        const xLabels = buildXLabels(seriesMaps);

        if (xLabels.length === 0) {
            return <div/>;
        }

        return (
            <div style={{backgroundColor: '#F2F2F2'}}>
                <LineChart
                    xAxis={[{scaleType: 'point', data: xLabels}]}
                    yAxis={[{tickMinStep: 1, tickMaxStep: 1}]}
                    series={seriesMaps}
                    width={1250}
                    height={600}
                />
            </div>
        );
    }

    return <div/>;
};
